import HubUpdates from "./HubUpdates";

export default HubUpdates;
